export const colors = {
    primary: '#EF4444',
    secondary: '#000000',
    tertiary: '#FF0000',
};